import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IOpening, IOpeningState } from "./openingsModal";
import {
  ActiveInactiveOpening,
  createOpening,
  deleteOpening,
  getAllActiveOpening,
  getAllOpening,
  getOpeningByID,
  updateOpening,
} from "./services/openings.services";

const initialState: IOpeningState = {
  loading: false,
  error: "",
  OpeningID: null,
  OpeningList: [],
  OpeningDetail: {
    Profile: "",
    Positions: 0,
    Experience: 0,
    Location: "",
    Eligibility: "",
    Summary: "",
    Responsibilities: "",
    IsActive: 1,
  },
};

const openingSlice = createSlice({
  name: "opening",
  initialState,
  reducers: {
    clearOpeningDetails: (state) => {
      state.OpeningDetail = initialState.OpeningDetail;
    },
    setOpeningID: (state, action) => {
      state.OpeningID = action.payload;
    },
    clearOpeningID: (state) => {
      state.OpeningID = initialState.OpeningID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllOpening.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllOpening.fulfilled,
      (state, action: PayloadAction<IOpening[]>) => {
        state.loading = false;
        state.OpeningList = action.payload || [];
      }
    );
    builder.addCase(getAllOpening.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.OpeningList = [];
    });
    builder.addCase(createOpening.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createOpening.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createOpening.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateOpening.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateOpening.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateOpening.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteOpening.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteOpening.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteOpening.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getOpeningByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getOpeningByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.OpeningDetail = action.payload;
    });
    builder.addCase(getOpeningByID.rejected, (state, action) => {
      state.loading = false;
      state.OpeningDetail = initialState.OpeningDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveOpening.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveOpening.fulfilled,
      (state, action: PayloadAction<IOpening[]>) => {
        state.loading = false;
        state.OpeningList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveOpening.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.OpeningList = [];
    });
    builder.addCase(ActiveInactiveOpening.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveOpening.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveOpening.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearOpeningDetails, clearOpeningID, setOpeningID } =
  openingSlice.actions;
export default openingSlice.reducer;
